import { render, staticRenderFns } from "./LeGenerateGameNews.vue?vue&type=template&id=aeceb456"
import script from "./LeGenerateGameNews.vue?vue&type=script&lang=js"
export * from "./LeGenerateGameNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports